
export const formattedDate = (date) => {
  const dateToFormat = new Date(date)

  const dateResult = dateToFormat.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "2-digit" })

  return dateResult
}
